import globalConfig from '@utiles/officialStore/globalConfig';
import { getServiceLink } from '@utiles/reviewFooter';
import { mapGetters, mapState } from 'vuex';
const mainHost = globalConfig.getMainHost();
export default {
  computed: {
    ...mapState({
      gameId: state => state.gameId
    }),
    ...mapGetters(['isJpPlatform']),
    isJp() {
      const iso_two_code =
        localStorage.getItem('locationDetectByIP') &&
        JSON.parse(localStorage.getItem('locationDetectByIP')); // 根据 IP 获取地区码
      const area = iso_two_code && iso_two_code['ISO_TWO_CODE'];
      return area === 'JP' || globalConfig.getLanguages() === 'ja-JP';
    },
    serviceLink() {
      const reviewServiceLink = getServiceLink(this.gameId);
      if (reviewServiceLink) {
        return reviewServiceLink;
      }
      // 2024.01.23 邓智轩：PNS（191）带参数p=pnsjp时替换服务条款链接
      if (this.gameId == 191 && globalConfig.getHrefParam('p') == 'pnsjp') {
        return `//gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/JpServicePrivacy/customize?keyWord=service_pnsjppay`;
      }
      if (this.isJpPlatform) {
        return `//gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/JpServicePrivicy/service?gameId=${this.gameId}&language=jp`;
      }
      return `//gpassport.${mainHost}/center/${
        this.isJp ? 'Jp' : ''
      }ServicePrivacy/service`;
    }
  }
};
